var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.fullLayout)?_c('router-view'):_c('dashboard'),_c('errors-notification',{attrs:{"id":"errors-notification"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }